import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { UserCircle } from 'lucide-react';
const CRM = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-2110">
      <div className="w-20 flex-shrink-0" data-id="element-2111">
        <Sidebar data-id="element-2112" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2113">
        <Topbar data-id="element-2114" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2115">
          <PageHeader title="CRM" subtitle="Customer Relationship Management" data-id="element-2116" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-2117">
            <div className="text-center" data-id="element-2118">
              <UserCircle className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-2119" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-2120">CRM</h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-2121">
                Questa pagina conterrà il sistema CRM. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default CRM;